/**
 * A global namespace for focus event names.
 */
const focusEvents = { in: 'focusin', out: 'focusout' };
export default focusEvents;
